<template><svg v-bind="$attrs"  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <rect width="23" height="23" x=".5" y=".5" rx="3.5"/>
  <path fill="#fff" d="M18.285 5.961 9.077 15.17l-3.361-3.396c-.176-.14-.456-.14-.596 0L4.105 12.79c-.14.14-.14.42 0 .595l4.691 4.656c.176.175.42.175.596 0L19.895 7.537c.14-.14.14-.42 0-.595l-1.015-.98c-.14-.176-.42-.176-.595 0Z"/>
</svg>
</template>